/**
 * ============================================================================
 * ESCROW DETAIL PAGE - 100% Ready
 * ============================================================================
 * 
 * Page for viewing and managing a single escrow
 */

import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { UserDashboardLayout } from '../components/user';
import EscrowDetails from '../components/escrow/EscrowDetails';
import Button from '../components/common/Button';
import { useI18n } from '../providers';

/**
 * Escrow Detail Page
 * @returns {JSX.Element}
 */
const EscrowDetail = () => {
  const navigate = useNavigate();
  const { language } = useI18n();

  return (
    <UserDashboardLayout>
      {/* Header */}
      <div className="mb-8 animate-fadeInUp">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate('/escrows')}
          className="mb-4"
        >
          ← {language === 'fr' ? 'Retour aux escrows' : 'Back to Escrows'}
        </Button>
      </div>

      {/* Escrow Details Component */}
      <div className="animate-fadeInUp" style={{ animationDelay: '0.1s' }}>
        <EscrowDetails />
      </div>
    </UserDashboardLayout>
  );
};

export default EscrowDetail;
